(() => {
  const STYLE_ID = 'dyu-shopify-chat-button-sizing';
  const HELP_TEXT_PATTERN = /need help\?/i;
  const MOBILE_QUERY = '(max-width: 749px)';
  const HELP_TEXT_FONT_SIZE = window.matchMedia(MOBILE_QUERY).matches ? '16px' : '18px';
  const CHAT_TOGGLE_SELECTOR = 'button.chat-toggle.chat-toggle--text-button';
  const CHAT_TOGGLE_BASE_SELECTOR = 'button.chat-toggle';
  const CHAT_MOBILE_ICON_SELECTOR = 'button.chat-toggle.chat-toggle--icon-button.icon-only svg, button.chat-toggle.chat-toggle--icon-button.mobile-only svg';
  const CHAT_CLOSE_BUTTON_SELECTOR = '.chat-app .chat-app--close-button';
  const CHAT_CLOSE_ICON_SELECTOR = `${CHAT_CLOSE_BUTTON_SELECTOR} svg`;
  const CHAT_ROUNDED_CONTROL_SELECTORS = [
    '.chat-app button.outline-button',
    '.chat-app .message-bubble',
    '.chat-app button.hover-effect-button',
    '.chat-app--is-open > div',
    '.chat-app .chat-header',
    '.chat-ui'
  ];
  const chatRoundedControlSelector = CHAT_ROUNDED_CONTROL_SELECTORS.join(',');
  const CHAT_HOVER_LABEL_SELECTOR = '.chat-app .hover-effect-button .label';
  const CHAT_STORE_INFO_HEADING_SELECTOR = '.interstitial-view__welcome .store-info-heading';
  const CHAT_OPEN_INTERNAL_SELECTORS = [
    '.chat-app--is-open',
    '.chat-app .chat-app--close-button',
    '.chat-app textarea',
    '.chat-app [contenteditable="true"]'
  ];
  const chatOpenInternalSelector = CHAT_OPEN_INTERNAL_SELECTORS.join(',');
  const WISER_MODAL_BODY_CLASS = 'dyu-wiser-modal-open-mobile';
  const CHAT_OPEN_BODY_CLASS = 'dyu-shopify-chat-open';
  const CHAT_BACKDROP_ID = 'dyu-shopify-chat-backdrop';

  const WISER_MODAL_SELECTORS = [
    '[class*=\"wiser\" i][class*=\"modal\" i]',
    '[id*=\"wiser\" i][id*=\"modal\" i]',
    '[class*=\"wiser\" i][class*=\"popup\" i]',
    '[id*=\"wiser\" i][id*=\"popup\" i]',
    '[class*=\"ws_\" i][class*=\"modal\" i]',
    '[class*=\"ws-\" i][class*=\"modal\" i]',
    '[id*=\"ws_\" i][id*=\"modal\" i]',
    '[id*=\"ws-\" i][id*=\"modal\" i]'
  ];

  const CHAT_HOST_SELECTORS = [
    '#ShopifyChat',
    '#shopify-chat',
    'shopify-chat',
    '.shopify-chat',
    '.chat-widget',
    'iframe[src*="inbox" i]',
    'iframe[id*="inbox" i]',
    'iframe[name*="inbox" i]',
    'iframe[src*="message" i]',
    'iframe[src*="messag" i]',
    'iframe[id*="shopify-chat" i]',
    'iframe[name*="shopify-chat" i]'
  ];

  const CHAT_LAUNCHER_SELECTORS = [
    'iframe#dummy-chat-button-iframe',
    'iframe[name="dummy-chat-button-iframe"]',
    'iframe[id*="shopify-chat" i]',
    'iframe[name*="shopify-chat" i]',
    'iframe[id*="chat-button" i]',
    'iframe[name*="chat-button" i]',
    'iframe[title*="chat button" i]',
    'iframe[aria-label*="chat button" i]'
  ];

  const CHAT_OVERLAY_SELECTORS = [
    ...CHAT_HOST_SELECTORS,
    ...CHAT_LAUNCHER_SELECTORS,
    'iframe[title*="chat" i]',
    'iframe[title*="message" i]',
    'iframe[title*="messag" i]',
    'iframe[aria-label*="chat" i]',
    'iframe[aria-label*="message" i]',
    'iframe[aria-label*="messag" i]',
    '[id*="ShopifyInbox" i]',
    '[id*="shopify-inbox" i]',
    '[class*="ShopifyInbox" i]',
    '[class*="shopify-inbox" i]'
  ];

  const chatHostSelector = CHAT_HOST_SELECTORS.join(',');
  const chatLauncherSelector = CHAT_LAUNCHER_SELECTORS.join(',');
  const chatSelector = [chatHostSelector, chatLauncherSelector].join(',');
  const chatOverlaySelector = CHAT_OVERLAY_SELECTORS.join(',');

  const pageStyle = `
    #${CHAT_BACKDROP_ID} {
      position: fixed;
      inset: 0;
      display: none;
      background: rgba(0, 0, 0, 0.52);
      z-index: 2147483646;
    }

    @media (min-width: 750px) {
      html.${CHAT_OPEN_BODY_CLASS} {
        overflow: hidden !important;
      }

      body.${CHAT_OPEN_BODY_CLASS} {
        overflow: hidden !important;
        overscroll-behavior: none;
      }

      html.${CHAT_OPEN_BODY_CLASS} body #${CHAT_BACKDROP_ID},
      body.${CHAT_OPEN_BODY_CLASS} #${CHAT_BACKDROP_ID} {
        display: block;
      }

      body.${CHAT_OPEN_BODY_CLASS} .header-scrolled,
      body.${CHAT_OPEN_BODY_CLASS} .header-sticky {
        pointer-events: auto;
      }

      body.${CHAT_OPEN_BODY_CLASS} .header-scrolled .header {
        transform: none;
      }
    }

    html.${CHAT_OPEN_BODY_CLASS} body ${chatSelector},
    body.${CHAT_OPEN_BODY_CLASS} ${chatSelector} {
      z-index: 2147483647 !important;
    }

    ${chatSelector} {
      display: block !important;
      opacity: 1 !important;
      visibility: visible !important;
      max-width: none !important;
      max-height: none !important;
      overflow: visible !important;
    }

    body.cart-template ${chatSelector},
    body.cart-drawer-open ${chatSelector},
    body:has(.cart-drawer[active]) ${chatSelector},
    body.${WISER_MODAL_BODY_CLASS} ${chatSelector} {
      display: none !important;
      opacity: 0 !important;
      visibility: hidden !important;
      pointer-events: none !important;
    }

    ${CHAT_TOGGLE_SELECTOR} {
      height: 54px !important;
      min-height: 54px !important;
      border-radius: 4px !important;
    }

    ${CHAT_CLOSE_BUTTON_SELECTOR} {
      height: 54px !important;
      width: 54px !important;
      margin-top: 5px !important;
    }

    ${CHAT_CLOSE_ICON_SELECTOR} {
      height: 24px !important;
      width: 24px !important;
    }

    ${chatRoundedControlSelector} {
      border-radius: 4px !important;
    }

    ${CHAT_HOVER_LABEL_SELECTOR} {
      color: #d8d2c7 !important;
    }

    ${CHAT_STORE_INFO_HEADING_SELECTOR} {
      margin-bottom: 15px !important;
    }

    @media ${MOBILE_QUERY} {
      body.collection-template ${chatSelector},
      body.search-template ${chatSelector} {
        display: none !important;
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
      }

      #${CHAT_BACKDROP_ID} {
        display: none !important;
      }

      html.${CHAT_OPEN_BODY_CLASS},
      body.${CHAT_OPEN_BODY_CLASS} {
        overflow: visible !important;
      }

      ${chatSelector} {
        z-index: 28 !important;
      }

      ${CHAT_TOGGLE_BASE_SELECTOR} {
        width: 48px !important;
        height: 48px !important;
      }

      ${CHAT_MOBILE_ICON_SELECTOR} {
        height: 42px !important;
      }
    }
  `;

  const chatInternalStyle = `
    ${CHAT_TOGGLE_SELECTOR} {
      height: 54px !important;
      min-height: 54px !important;
      border-radius: 4px !important;
    }

    ${CHAT_CLOSE_BUTTON_SELECTOR} {
      height: 54px !important;
      width: 54px !important;
      margin-top: 5px !important;
    }

    ${CHAT_CLOSE_ICON_SELECTOR} {
      height: 24px !important;
      width: 24px !important;
    }

    ${chatRoundedControlSelector} {
      border-radius: 4px !important;
    }

    ${CHAT_HOVER_LABEL_SELECTOR} {
      color: #d8d2c7 !important;
    }

    ${CHAT_STORE_INFO_HEADING_SELECTOR} {
      margin-bottom: 15px !important;
    }

    @media ${MOBILE_QUERY} {
      ${CHAT_TOGGLE_BASE_SELECTOR} {
        width: 48px !important;
        height: 48px !important;
      }

      ${CHAT_MOBILE_ICON_SELECTOR} {
        height: 42px !important;
      }
    }
  `;

  const upsertStyle = (root, cssText) => {
    if (!root) return;

    let style = root.getElementById?.(STYLE_ID);
    if (!style) {
      style = (root.createElement ? root : root.ownerDocument).createElement('style');
      style.id = STYLE_ID;
      (root.head || root.documentElement || root).appendChild(style);
    }

    if (style.textContent !== cssText) {
      style.textContent = cssText;
    }
  };

  const isLikelyShopifyChatElement = (element) => {
    const label = `${element.id || ''} ${element.className || ''} ${element.getAttribute('name') || ''} ${element.getAttribute('title') || ''} ${element.getAttribute('aria-label') || ''} ${element.getAttribute('src') || ''} ${element.localName || ''}`;
    return /shopify-chat|ShopifyChat|shopify-inbox|ShopifyInbox|chat-button|dummy-chat-button|inbox|messag/i.test(label);
  };

  const isMobileView = () => window.matchMedia(MOBILE_QUERY).matches;
  const shouldUseChatOverlay = () => !isMobileView();

  const isMobileListingPage = () => {
    if (!isMobileView()) return false;

    return Boolean(
      document.body?.classList.contains('collection-template') ||
        document.body?.classList.contains('search-template')
    );
  };

  const isCartContext = () =>
    Boolean(
      document.body?.classList.contains('cart-template') ||
        document.body?.classList.contains('cart-drawer-open') ||
        document.querySelector('.cart-drawer[active]')
    );

  const isVisibleElement = (element) => {
    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;

    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;

    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  };

  const isLikelyWiserModalOpen = () => {
    if (!isMobileView()) return false;

    return WISER_MODAL_SELECTORS.some((selector) => {
      try {
        return Array.from(document.querySelectorAll(selector)).some(isVisibleElement);
      } catch (error) {
        return false;
      }
    });
  };

  const setWiserModalState = () => {
    document.body?.classList.toggle(WISER_MODAL_BODY_CLASS, isLikelyWiserModalOpen());
  };

  const hideChatElement = (element) => {
    if (!isLikelyShopifyChatElement(element)) return;

    element.style.setProperty('display', 'none', 'important');
    element.style.setProperty('opacity', '0', 'important');
    element.style.setProperty('visibility', 'hidden', 'important');
    element.style.setProperty('pointer-events', 'none', 'important');
  };


  const ensureChatBackdrop = () => {
    let backdrop = document.getElementById(CHAT_BACKDROP_ID);
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.id = CHAT_BACKDROP_ID;
      backdrop.setAttribute('aria-hidden', 'true');
      document.body?.appendChild(backdrop);
    }

    return backdrop;
  };

  const isChatLauncherOnlyElement = (element) => {
    const label = `${element.id || ''} ${element.getAttribute('name') || ''} ${element.getAttribute('title') || ''} ${element.getAttribute('aria-label') || ''}`;
    return /dummy-chat-button|chat-button/i.test(label);
  };

  const isViewportSizedChatOverlay = (element) => {
    if (isChatLauncherOnlyElement(element) || !isVisibleElement(element)) return false;

    const rect = element.getBoundingClientRect();
    return rect.width >= window.innerWidth * 0.8 && rect.height >= window.innerHeight * 0.8;
  };

  const rootHasOpenChatPanel = (root) => {
    if (!root) return false;

    try {
      return Array.from(root.querySelectorAll(chatOpenInternalSelector)).some(isVisibleElement);
    } catch (error) {
      return false;
    }
  };

  const elementHasOpenChatPanel = (element) => {
    if (!isLikelyShopifyChatElement(element) || !isVisibleElement(element) || isChatLauncherOnlyElement(element)) return false;

    if (element.shadowRoot && rootHasOpenChatPanel(element.shadowRoot)) return true;

    if (element.tagName === 'IFRAME') {
      try {
        return rootHasOpenChatPanel(element.contentDocument);
      } catch (error) {
        return false;
      }
    }

    return element.matches?.(chatOpenInternalSelector) || rootHasOpenChatPanel(element);
  };

  const isChatPanelOpen = () => {
    if (!document.body || !shouldUseChatOverlay() || isCartContext() || document.body.classList.contains(WISER_MODAL_BODY_CLASS) || isMobileListingPage()) {
      return false;
    }

    return Array.from(document.querySelectorAll(chatSelector)).some(elementHasOpenChatPanel);
  };

  const setChatOverlayState = (isOpen) => {
    if (!document.body) return;

    ensureChatBackdrop();

    if (!shouldUseChatOverlay()) {
      isOpen = false;
    }

    if (isOpen) {
      document.documentElement.classList.add(CHAT_OPEN_BODY_CLASS);
      document.body.classList.add(CHAT_OPEN_BODY_CLASS);
      return;
    }

    if (document.body.classList.contains(CHAT_OPEN_BODY_CLASS)) {
      document.documentElement.classList.remove(CHAT_OPEN_BODY_CLASS);
      document.body.classList.remove(CHAT_OPEN_BODY_CLASS);
    }
  };

  const styleMobileChatControls = (root) => {
    if (!root || !isMobileView()) return;

    root.querySelectorAll(CHAT_TOGGLE_BASE_SELECTOR).forEach((element) => {
      element.style.setProperty('width', '48px', 'important');
      element.style.setProperty('height', '48px', 'important');
    });

    root.querySelectorAll(CHAT_MOBILE_ICON_SELECTOR).forEach((element) => {
      element.style.setProperty('height', '42px', 'important');
    });
  };

  const styleChatControls = (root) => {
    if (!root) return;

    upsertStyle(root, chatInternalStyle);

    root.querySelectorAll(CHAT_TOGGLE_SELECTOR).forEach((element) => {
      element.style.setProperty('height', '54px', 'important');
      element.style.setProperty('min-height', '54px', 'important');
      element.style.setProperty('border-radius', '4px', 'important');
    });

    root.querySelectorAll(CHAT_CLOSE_BUTTON_SELECTOR).forEach((element) => {
      element.style.setProperty('height', '54px', 'important');
      element.style.setProperty('width', '54px', 'important');
      element.style.setProperty('margin-top', '5px', 'important');
    });

    root.querySelectorAll(CHAT_CLOSE_ICON_SELECTOR).forEach((element) => {
      element.setAttribute('width', '24');
      element.setAttribute('height', '24');
      element.style.setProperty('height', '24px', 'important');
      element.style.setProperty('width', '24px', 'important');
    });

    root.querySelectorAll(chatRoundedControlSelector).forEach((element) => {
      element.style.setProperty('border-radius', '4px', 'important');
    });

    root.querySelectorAll(CHAT_HOVER_LABEL_SELECTOR).forEach((element) => {
      element.style.setProperty('color', '#d8d2c7', 'important');
    });

    root.querySelectorAll(CHAT_STORE_INFO_HEADING_SELECTOR).forEach((element) => {
      element.style.setProperty('margin-bottom', '15px', 'important');
    });

    styleMobileChatControls(root);
  };

  const reduceHelpTextSize = (root) => {
    if (!root) return;

    styleChatControls(root);

    root.querySelectorAll('button, [role="button"], span, div, p').forEach((element) => {
      if (HELP_TEXT_PATTERN.test(element.textContent?.trim() || '')) {
        element.style.setProperty('font-size', HELP_TEXT_FONT_SIZE, 'important');
        element.style.setProperty('line-height', '1.15', 'important');
      }
    });
  };

  const restoreChatElement = (element) => {
    if (!isLikelyShopifyChatElement(element)) return;

    element.style.setProperty('display', 'block', 'important');
    element.style.setProperty('opacity', '1', 'important');
    element.style.setProperty('visibility', 'visible', 'important');
    if (isViewportSizedChatOverlay(element) && !elementHasOpenChatPanel(element)) {
      element.style.setProperty('pointer-events', 'none', 'important');
      element.style.setProperty('z-index', '28', 'important');
    } else {
      element.style.setProperty('pointer-events', 'auto', 'important');
      element.style.setProperty('z-index', isMobileView() ? '28' : '2147483647', 'important');
    }
    element.style.setProperty('max-width', 'none', 'important');
    element.style.setProperty('max-height', 'none', 'important');
    element.style.setProperty('overflow', 'visible', 'important');
    element.style.removeProperty('transform');

    if (element.matches?.(CHAT_TOGGLE_SELECTOR)) {
      element.style.setProperty('height', '54px', 'important');
      element.style.setProperty('min-height', '54px', 'important');
      element.style.setProperty('border-radius', '4px', 'important');
    }

    if (element.matches?.(CHAT_CLOSE_BUTTON_SELECTOR)) {
      element.style.setProperty('height', '54px', 'important');
      element.style.setProperty('width', '54px', 'important');
      element.style.setProperty('margin-top', '5px', 'important');
    }

    if (element.matches?.(CHAT_CLOSE_ICON_SELECTOR)) {
      element.setAttribute('width', '24');
      element.setAttribute('height', '24');
      element.style.setProperty('height', '24px', 'important');
      element.style.setProperty('width', '24px', 'important');
    }

    if (element.matches?.(chatRoundedControlSelector)) {
      element.style.setProperty('border-radius', '4px', 'important');
    }

    if (element.matches?.(CHAT_HOVER_LABEL_SELECTOR)) {
      element.style.setProperty('color', '#d8d2c7', 'important');
    }

    if (element.matches?.(CHAT_STORE_INFO_HEADING_SELECTOR)) {
      element.style.setProperty('margin-bottom', '15px', 'important');
    }

    if (isMobileView() && element.matches?.(CHAT_TOGGLE_BASE_SELECTOR)) {
      element.style.setProperty('width', '48px', 'important');
      element.style.setProperty('height', '48px', 'important');
    }

    if (isMobileView() && element.matches?.(CHAT_MOBILE_ICON_SELECTOR)) {
      element.style.setProperty('height', '42px', 'important');
    }

    if (element.shadowRoot) {
      reduceHelpTextSize(element.shadowRoot);
    }

    if (element.tagName === 'IFRAME') {
      try {
        reduceHelpTextSize(element.contentDocument);
      } catch (error) {
        /* Cross-origin Shopify Inbox frames cannot be styled internally. */
      }
    }
  };

  const neutralizeClosedChatOverlays = () => {
    document.querySelectorAll(chatOverlaySelector).forEach((element) => {
      if (!isLikelyShopifyChatElement(element) || !isViewportSizedChatOverlay(element) || elementHasOpenChatPanel(element)) return;

      element.style.setProperty('pointer-events', 'none', 'important');
      element.style.setProperty('z-index', '28', 'important');
    });
  };

  const styleChatWidget = () => {
    upsertStyle(document, pageStyle);
    setWiserModalState();

    const shouldHideChat = isCartContext() || document.body?.classList.contains(WISER_MODAL_BODY_CLASS) || isMobileListingPage();
    document.querySelectorAll(chatSelector).forEach(shouldHideChat ? hideChatElement : restoreChatElement);
    if (!shouldHideChat) neutralizeClosedChatOverlays();
    setChatOverlayState(!shouldHideChat && isChatPanelOpen());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', styleChatWidget, { once: true });
  } else {
    styleChatWidget();
  }

  window.addEventListener('load', styleChatWidget, { once: true });
  window.addEventListener('resize', styleChatWidget);
  window.setInterval(styleChatWidget, 500);

  let animationFrame = null;
  const observer = new MutationObserver(() => {
    if (animationFrame) return;
    animationFrame = window.requestAnimationFrame(() => {
      animationFrame = null;
      styleChatWidget();
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
